import React, {useEffect, useImperativeHandle} from "react";
import { Col, Divider, Form, Input,InputNumber, Row, Switch, TreeSelect,Select} from "antd";
import {useModel,useModelDispatchers} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import {useHistory} from "react-router";
import {goPage} from "../../layout/pageDefinition";

const tailLayout = {
    labelCol: {span: 3}
};

const dataTransfer = (data) => {
    let formData = data;
    formData.detail = [];
    if (data.supplierPerson2 || data.supplierPhone2) {
        formData.detail.push({supplierPerson: data.supplierPerson2, supplierPhone: data.supplierPhone2});
    }
    if (data.supplierPerson3 || data.supplierPhone3) {
        formData.detail.push({supplierPerson: data.supplierPerson3, supplierPhone: data.supplierPhone3});
    }
    return formData;
};

export default function ({formRef, actionType}) {
    const history = useHistory();
    const [{customerTypeDict,opnBankDict}, {getCustomerTypeDict,getAccountTypeDict,getOpnBankDict}] = useModel("cmDict");
    const {closeNav} = useModelDispatchers("nav");

    useEffect(() => {
        getCustomerTypeDict();
        getAccountTypeDict();
        getOpnBankDict()
    }, []);

    const [form] = Form.useForm();
    const [{selectedCustomer}, {insert, update}] = useModel("customer");

    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedCustomer) {
                // console.log()
                form.setFieldsValue(selectedCustomer)
                const {customerStatus} = selectedCustomer;
                console.log(customerStatus)
                form.setFieldsValue({"customerStatus": !!(customerStatus == 0)});
            }
        }else if(actionType === CM_ACTION_TYPE.INSERT){
            form.setFieldsValue({"customerStatus": true});
        }   
        form.setFieldsValue({"customerAgency":"天路云卡张家口汽车销售有限公司"});
    }, [actionType, selectedCustomer])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: () => {
            form.validateFields().then(data => {
                let {customerStatus} = data
                if(customerStatus==undefined||customerStatus==true){
                    customerStatus=0
                }else{
                    customerStatus=1
                }
                insert({...data,customerStatus,updateTime:null}).then(res=>{
                    if(!!res){
                        closeNav();
                        goPage(history, "6-4");
                    }
                });
            })
        },
        update: () => {
            form.validateFields().then(data => {
                let {customerStatus} = data
                if(customerStatus==undefined||customerStatus==true){
                    customerStatus=0
                }else{
                    customerStatus=1
                }
                update({...data,customerStatus,updateTime:null,id:selectedCustomer.id}).then(res=>{
                    if(!!res){
                        closeNav();
                        goPage(history, "6-4");
                    }
                });
            })
        },
        reset: () => {
            form.resetFields();
            if(actionType === CM_ACTION_TYPE.INSERT){
                form.setFieldsValue({"customerAgency":"天路云卡张家口汽车销售有限公司"});
            }else if(actionType === CM_ACTION_TYPE.EDIT){
                let {customerCode,createUser,createTime,updateUser,updateTime} = selectedCustomer
                form.setFieldsValue({"customerAgency":"天路云卡张家口汽车销售有限公司"});
                form.setFieldsValue({customerCode,createUser,createTime,updateUser,updateTime});
            }
        },
    }));
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 6}}
        >

            {/*<Divider orientation="left" plain>基本信息</Divider>*/}

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerCode"
                        label="客户编码"
                    >
                        <Input disabled={true} placeholder="客户编码"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerName"
                        label="客户名称"
                        rules={[{ required: true, message: '请输入客户名称' }]}
                    >
                        <Input placeholder="客户名称"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerType"
                        label="客户类型"
                        rules={[{ required: true, message: '请选择客户类型' }]}

                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                            placeholder="客户类型"
                            treeDefaultExpandAll
                            onChange={() => {
                            }}
                            treeData={customerTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerLevel"
                        label="客户级别"
                        // rules={[{ type: "number", message: '客户级别是数字' }]}
                    >
                        <InputNumber placeholder="客户级别"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerCorporation"
                        label="联系人"
                        
                    >
                        <Input placeholder="联系人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerCorporationPhone"
                        label="联系电话"
                        rules={[{pattern:/^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/, message: '电话格式不正确' }]}
                    >
                        <Input placeholder="联系电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerPhone"
                        label="办公电话"
                    >
                        <Input placeholder="办公电话"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerEmail"
                        label="电子邮箱"
                        rules={[{type:"email", message: '邮箱格式不正确' }]}

                    >
                        <Input placeholder="电子邮箱"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerSecondContact"
                        label="联系人2"
                    >
                        <Input placeholder="联系人2"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="secondContactPhone"
                        label="联系电话2"
                        rules={[{pattern:/^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/, message: '电话格式不正确' }]}

                    >
                        <Input placeholder="联系电话2"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerFax"
                        label="传真号码"
                    >
                        <Input placeholder="传真号码"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerUrl"
                        label="公司网址"
                    >
                        <Input placeholder="公司网址"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerAddress"
                        label="联系地址"
                    >
                        <Input placeholder="联系地址"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerAgency"
                        label="所属公司"
                    >
                        <Input disabled placeholder="所属公司"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerDesc"
                        label="备注"
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" plain>开票信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="invoicingProcess"
                        label="发票抬头"
                    >
                        <Input placeholder="发票抬头"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="licenseNumber"
                        label="营业执照"
                    >
                        <Input placeholder="营业执照"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="bankName"
                        label="开户银行"
                    >
                        {/* <Input placeholder="开户银行"/> */}
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="开户银行"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={opnBankDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="bankAccount"
                        label="银行账号"
                        // rules={[{type:"number",min:0,max:20}]}
                        // rules={[{type:"number", message: '银行账号是数字'}]}
                    >
                        <Input placeholder="银行账号"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="businessAddress"
                        label="邮寄地址"
                    >
                        <Input placeholder="邮寄地址"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="corporate"
                        label="公司法人"
                    >
                        <Input placeholder="公司法人"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="businessScope"
                        label="经营范围"
                        {...tailLayout}
                    >
                        <Input placeholder="经营范围"/>
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" plain>其他信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="createUser"
                        label="创建人"
                    >
                        <Input disabled={true} placeholder="创建人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="createTime"
                        label="创建时间"
                    >
                        <Input disabled={true} placeholder="创建时间"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="updateUser"
                        label="修改人"
                    >
                        <Input disabled={true} placeholder="修改人"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="updateTime"
                        label="修改时间"
                    >
                        <Input disabled={true} placeholder="修改时间"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="customerStatus"
                        label="是否启用"
                        valuePropName="checked"
                    >
                        <Switch size="default"/>
                    </Form.Item>
                </Col>
                <Col span={18}>
                </Col>
            </Row>
        </Form>
    )
}